import { useTheme } from 'styled-components';
export const useMixin = (mixin) => {
    const theme = useTheme();
    return mixin({ theme });
};
//# sourceMappingURL=useMixin.js.map